// バックエンドエラーメッセージ → i18n キー のマッピング
export const backendErrorMessages = {
  The_domain_name_may_not_be_set_to_null: "backend.error.domain_name_null",
  Must_provide_a_domain_names: "backend.error.must_provide_domain_name",
  The_domain_names_format_is_invalid: "backend.error.domain_name_format_invalid",
  The_companyPassword_may_not_be_set_to_null: "backend.error.company_password_null",
  Must_provide_a_company_password: "backend.error.must_provide_company_password",
  The_email_may_not_be_set_to_null: "backend.error.email_null",
  The_password_may_not_be_set_to_null: "backend.error.password_null",
  The_company_is_not_exist: "backend.error.company_not_exist",
  The_companyPassword_is_wrong: "backend.error.company_password_wrong",
  The_member_is_not_exist: "backend.error.member_not_exist",
};

/**
 * バックエンドエラーメッセージを i18n キーに変換する
 * @param {string} message - バックエンドから返ってきた errorMessage
 * @param {string} fallbackKey - マッピングがない場合のデフォルトキー
 * @returns {string} i18n キー
 */
export const resolveBackendErrorKey = (message, fallbackKey = "auth.error.signin") => {
  return backendErrorMessages[message] || fallbackKey;
};
